export default "__VITE_ASSET__3HNt_JiI__"